<template>
  <a-dropdown :trigger="['click']" placement="bottomCenter">
    <div :class="$style.dropdown">
      <span class="text-uppercase">{{ language }}</span>
    </div>
    <a-menu slot="overlay" @click="selectLocale" :class="$style.menuItem">
      <a-menu-item key="en">
        <span class="text-uppercase font-size-12 mr-2">EN</span>
        English
      </a-menu-item>
      <a-menu-item key="es">
        <span class="text-uppercase font-size-12 mr-2">ES</span>
        Spanish
      </a-menu-item>
      <a-menu-item key="fr">
        <span class="text-uppercase font-size-12 mr-2">FR</span>
        French
      </a-menu-item>
      <a-menu-item key="ko">
        <span class="text-uppercase font-size-12 mr-2">KO</span>
        Korean
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import { replace } from 'lodash';

export default {
  computed: {
    ...mapState(['settings']),
    language() {
      return this.settings.locale;
    },
  },
  methods: {
    selectLocale(item) {
      let path = this.$route.path;
      path = replace(path, '/es/', '/');
      path = replace(path, '/fr/', '/');
      path = replace(path, '/ko/', '/');
      if (item.key === 'es') {
        path = '/es' + path;
      } else if (item.key === 'fr') {
        path = '/fr' + path;
      } else if (item.key === 'ko') {
        path = '/ko' + path;
      }
      const setting = 'locale';
      this.$store.commit('CHANGE_SETTING', { setting, value: item.key });
      this.$router.replace({ path });
    },
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
